// Getters
export const GET_MUNICIPAL_IPS = 'auth/GET_MUNICIPAL_IPS';
// Mutations
export const MUTATE_SET_MUNICIPAL_IPS = 'auth/MUTATE_SET_MUNICIPAL_IPS';
// Actions
export const SET_MUNICIPAL_IPS = 'auth/SET_MUNICIPAL_IPS';
export const RESET_MUNICIPAL_AND_INSTITUTION = 'auth/RESET_MUNICIPAL_AND_INSTITUTION';
